<template>
  <section class="content">
    <div class="row">

      <div class="col-md-12">
        <div class="box box-solid">

          <div class="box-header with-border">
            <h3 class="box-title"><b>{{ $route.meta.description }}</b></h3>
          </div>

          <div class="box-body">
            <form style="width:100%" method="POST" @submit.prevent="commit" ref="empresa">

              <div class="row">
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for="razao">Razão Social</label>
                    <input class="form-control" name="razao" type="text" v-model="dados.razao">
                  </div>
                </div>

                <div class="col-sm-4">
                  <div class="form-group">
                    <label for="fantasia">Nome de Fantasia</label>
                    <input class="form-control" name="fantasia" type="text" v-model="dados.fantasia">
                  </div>
                </div>

                <div class="col-sm-2">
                  <div class="form-group">
                    <label for="cpf_cnpj">CNPJ</label>
                    <input class="form-control cnpj_mask" name="cpf_cnpj" type="text" v-model="dados.cpf_cnpj">
                  </div>
                </div>

                <div class="col-sm-2">
                  <div class="form-group">
                    <label for="insc_estadual">Inscrição Estadual</label>
                    <input class="form-control" name="insc_estadual" type="text" v-model="dados.insc_estadual">
                  </div>
                </div>

                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="endereco">Endereço</label>
                    <input class="form-control" name="endereco" type="text" v-model="dados.endereco">
                  </div>
                </div>

                <div class="col-sm-1">
                  <div class="form-group">
                    <label for="numero">Número</label>
                    <input class="form-control" name="numero" type="text" v-model="dados.numero">
                  </div>
                </div>

                <div class="col-sm-5">
                  <div class="form-group">
                    <label for="complemento">Complemento</label>
                    <input class="form-control" name="complemento" type="text" v-model="dados.complemento">
                  </div>
                </div>

                <div class="col-sm-5">
                  <div class="form-group">
                    <label for="bairro">Bairro</label>
                    <input class="form-control" name="bairro" type="text" v-model="dados.bairro">
                  </div>
                </div>

                <div class="col-sm-2">
                  <div class="form-group">
                    <label for="cep">CEP</label>
                    <input class="form-control cep_mask" name="cep" type="text" v-model="dados.cep">
                  </div>
                </div>

                <div class="col-sm-2">
                  <div class="form-group">
                    <label for="uf_id">Estado</label>
                    <select class="form-control" v-model="dados.uf_id">
                      <option>--Estado--</option>

                    </select>
                  </div>
                </div>

                <div class="col-sm-3">
                  <div class="form-group" v-model="dados.select-cidades">
                    <label for="cidade_id">Cidade</label>
                    <select class="form-control" name="cidade_id" v-model="dados.cidade_id">
                      <option>--Cidade--</option>
                    </select>
                  </div>
                </div>


                <div class="col-sm-3">
                  <div class="form-group">
                    <label for="responsavel">Responsável</label>
                    <input class="form-control" name="responsavel" type="text" v-model="dados.responsavel">
                  </div>
                </div>
                <div class="col-sm-2">
                  <div class="form-group">
                    <label for="tel1">Telefone 1</label>
                    <input class="form-control phone_mask" name="tel1" type="text" v-model="dados.tel1">
                  </div>
                </div>

                <div class="col-sm-2">
                  <div class="form-group">
                    <label for="tel2">Telefone 2</label>
                    <input class="form-control phone_mask" name="tel2" type="text" v-model="dados.tel2">
                  </div>
                </div>

                <div class="col-sm-2">
                  <div class="form-group">
                    <label for="tel3">Telefone 3</label>
                    <input class="form-control phone_mask" name="tel3" type="text" v-model="dados.tel3">
                  </div>
                </div>

                <div class="col-sm-3">
                  <div class="form-group">
                    <label for="email">E-mail</label>
                    <input class="form-control" name="email" type="text" v-model="dados.email">
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div class="box-footer">
          <h4>Definições Contratuais</h4>
            <div class="row">
              <div class="col-sm-3">
                <div class="form-group">
                  <label for="uf_id">CDL</label>
                  <select class="form-control" v-model="dados.uf_id">
                    <option>--CDL--</option>
                  </select>
                </div>
              </div>

              <div class="col-sm-3">
                <div class="form-group">
                  <label for="uf_id">Dia do Fechamento</label>
                  <select class="form-control" v-model="dados.uf_id">
                    <option value='03'>03</option>
                    <option value='10'>10</option>
                    <option value='18'>18</option>
                    <option value='25'>25</option>
                  </select>
                </div>
              </div>

              <div class="col-sm-3">
                <div class="form-group">
                  <label for="uf_id">Vlr C. Restritiva</label>
                  <input class="form-control" name="email" type="text" v-model="dados.email">
                </div>
              </div>

              <div class="col-sm-3">
                <div class="form-group">
                  <label for="uf_id">Vlr C. Analítica</label>
                  <input class="form-control" name="email" type="text" v-model="dados.email">
                </div>
              </div>



            </div>
          </div>

          <div class="box-footer text-right">
            <router-link tag="a"  to="/usuarios" class="btn btn-default">Voltar</router-link>
            <input class="btn btn-primary" type="submit" value="Salvar">
          </div>

        </div>
      </div>
    </div>
  </section>
</template>



<script>

  import axios from 'axios'
  import vSelect from 'vue-select'
  import {mask} from 'vue-the-mask'

  export default {
    directives: {mask},
    components: {
      vSelect
    },
    data: () => ({
      dados: {
        id: null,
        name: '',
        usuario: '',
        email: '',
        password: '',
        cpf: '',
        telefone: '',
        nivel: '',
        cidades: []
      },
      confirmacaoSenha: '',
      cidadesSelecionadas: [],
      showSetorArvore: false,
      listCidades: [],
      atualizacao: false,

    }),
    mounted() {
      this.getListCidades();
      if (this.$route.params.idUsuario) {
        this.getUserById(this.$route.params.idUsuario);
        this.atualizacao = true;
      }
    },
    methods: {
      getListCidades() {

        this.$store.commit('TOGGLE_LOADING');

        axios.get(`${this.$store.state.serverURI}/api/cidade/dataForSelect`, this.$store.getters.getHeaderAuth).then(response => {

          var stringified = JSON.stringify(response.data);
          stringified = stringified.replace(/nome/g, 'label');
          var data = JSON.parse(stringified);

          this.listCidades = data; 
          this.$store.commit('TOGGLE_LOADING');

        }).catch((error) => { console.log(error) });

      },

      getUserById(id) {
        this.$store.commit('TOGGLE_LOADING');
        axios.get(`${this.$store.state.serverURI}/api/usuario/getById/` + id, this.$store.getters.getHeaderAuth).then(response => {
          console.log(response.data);
          this.dados.id = response.data.id;
          this.dados.name = response.data.name;
          this.dados.usuario = response.data.usuario;
          this.dados.email = response.data.email;
          this.dados.nivel = response.data.nivel;
          this.dados.telefone = response.data.telefone;
          this.dados.cpf = response.data.cpf;
          var stringified = JSON.stringify(response.data.cidades);
          stringified = stringified.replace(/nome/g, 'label');
          var cidadesSelecionadas = JSON.parse(stringified);
          this.cidadesSelecionadas = cidadesSelecionadas;

          this.$store.commit('TOGGLE_LOADING');

        }).catch((error) => { console.log(error) });
      },
      commit() {

        this.$validator.validateAll().then((result) => {
          if (result) {
            this.$store.commit('TOGGLE_LOADING');
            if (this.atualizacao) {

              axios.post(`${this.$store.state.serverURI}/api/usuario/update/` + this.dados.id, this.dados, this.$store.getters.getHeaderAuth).then(response => {

                this.$store.commit('SHOW_ALERT_SUCCESS');
                this.$router.push('/usuarios');

              }).catch((error) => {
                this.$store.commit('SHOW_ALERT_ERROR');
                console.log(error)
              });

            } else {

              axios.post(`${this.$store.state.serverURI}/api/usuario/store`, this.dados, this.$store.getters.getHeaderAuth).then(response => {
                this.$store.commit('SHOW_ALERT_SUCCESS');
                this.$router.push('/usuarios');

              }).catch((error) => {
                this.$store.commit('SHOW_ALERT_ERROR');
                console.log(error);
              });

            }
          }
          this.$store.commit('TOGGLE_LOADING');
          return false;
        });

      },

    },
    watch: {
      cidadesSelecionadas: function (value, oldValue) {
        let cidades = [];
        for (let i=0; i<value.length; i++) {
          cidades[i] = value[i].id;
        }
        this.dados.cidades = cidades;
      }
    }
  }
</script>

<style scoped>
  form{
    padding: 0;
  }


  /* Customize the label (the container-checks) */
  .container-checks {
    display: inline;
    position: relative;
    padding-left: 35px;
    margin-bottom: 12px;
    cursor: pointer;
    font-size: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  /* Hide the browser's default checkbox */
  .container-checks input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }
  /* Create a custom checkbox */
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 25px;
    width: 25px;
    background-color: #fafafa;
    border: 1px solid #999;
  }
  /* On mouse-over, add a grey background color */
  .container-checks:hover input ~ .checkmark {
    background-color: #F3D999;
    border: none;
  }
  /* When the checkbox is checked, add a blue background */
  .container-checks input:checked ~ .checkmark {
    background-color: #f39c12;
  }

  .container-checks input:disabled ~ .checkmark {
    background-color: #ccc;
    border: 1px solid #ccc;
  }
  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }
  /* Show the checkmark when checked */
  .container-checks input:checked ~ .checkmark:after {
    display: block;
  }
  /* Style the checkmark/indicator */
  .container-checks .checkmark:after {
    left: 9px;
    top: 5px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  } 

  .titulo-permissoes {
    text-align: center;
    font-size: 12px;
    background-color: #f39c12;
    border: 1px solid #e08e0b;
    color: #fafafa;
    padding: 2px;
  }
</style>



// WEBPACK FOOTER //
// Form.vue?d44d2884